export const ASSET_LIBRARY_OWNERSHIP_OPTIONS = {
  media: {
    owner: {
      name: 'Show Owner Media',
    },
    portal: {
      name: 'Show Safari Portal Media',
    },
    all: {
      name: 'Show All Media',
    },
    public: {
      name: 'Show Public Media',
    },
    private: {
      name: 'Show Private Media',
    },
    primary: {
      name: 'Show Primary Photo',
    },
  },
  document: {
    active: { name: 'View Active' },
    archive: { name: 'View Inactive' },
    all: { name: 'View All' },
  },
};
